import React from 'react';
import { registerWidget } from '@okapi/core';
import { BrandsWidget } from 'entries/common/widgets';
import type { BrandsProps } from 'features/brands/types';
import type { SharedBannerSingleResponse } from 'api/types';
import { fetchApiClient } from 'api/fetch-api-client/fetch-api-client';
import { impressionClickTracking, impressionViewTracking } from 'api/fetch-api-client/tracking';
import { EnvState } from 'api/fetch-api-client/types';

registerWidget<SharedBannerSingleResponse & EnvState, BrandsProps>(`${__NAME__}/brands`, serverData => {
  return props => {
    if (!serverData.env) {
      return <BrandsWidget {...props} brands={serverData} />;
    }

    const contentIdClicked: string[] = [];

    const { env } = serverData;

    if (env) {
      fetchApiClient.setHost(serverData.env.host);
      fetchApiClient.addDefaultHeader('x-api-key', serverData.env.apiKey);
    }

    const onImpressionContentClick = (brandId: string) => {
      if (!contentIdClicked.includes(brandId)) {
        impressionClickTracking(brandId);
      }

      contentIdClicked.push(brandId);
    };

    const onImpressionContentView = (brandId: string) => {
      impressionViewTracking(brandId);
    };

    return (
      <BrandsWidget
        {...props}
        brands={serverData}
        onImpressionContentClick={onImpressionContentClick}
        onImpressionContentView={onImpressionContentView}
      />
    );
  };
});
